import axios from "axios";

export default {
	// 获取-index-xml
	getIndexXml() {
		return axios.get(`/krpano/vr-preview-xml/index.xml?v=202008011110`);
	},
	
	
	
};
